'use strict';

var _taggedTemplateLiteral = require("/var/apps/finb/axis-frontend/axis-fe-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

function _templateObject9() {
  var data = _taggedTemplateLiteral(["\n      height: 100%;\n\n      &:hover {\n        ", " {\n          transform: translateY(0);\n          opacity: 1;\n          visibility: visible;\n        }\n      }\n    "]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n  display: flex;\n  ", ";\n"]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n      position: absolute;\n      top: 100%;\n      right: 0;\n      min-width: 136px;\n      transform: translateY(-10px);\n      opacity: 0;\n      visibility: hidden;\n\n    "]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  transition: transform 0.25s, opacity 0.25s, visibility 0.25s;\n\n  ", ";\n\n  ", ",\n  ", " {\n    width: 100%;\n  }\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n      ", ",\n      ", " {\n        color: black;\n        background-color: white;\n\n\n        &:hover {\n          //background-color: ", ";\n          color: white;\n        }\n\n        &.active {\n          //background-color: ", ";\n        }\n      }\n    "]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n      margin-top: 2px;\n\n      ", " {\n        height: auto;\n        width: 100%;\n        margin-left: 0;\n        margin-right: 0;\n      }\n\n      ", ",\n      ", " {\n        height: 48px;\n        width: 100%;\n        border-bottom: 0;\n        font-weight: bold;\n      }\n    "]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  display: block;\n  width: 100%;\n\n  ", ";\n\n  ", ";\n\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n      width: 100%;\n      justify-content: space-between;\n      padding-left: 16px;\n    "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  cursor: pointer;\n\n  ", ";\n  .icon-user {\n    margin-right: 10px;\n  }\n  .fa-angle-down {\n    margin-left: 14px;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SubMenu = exports.SubMenuListWrapper = exports.SubMenuList = exports.SubMenuTitle = undefined;

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _styled = require('../../../styled');

var _theme = require('../../../styled/theme');

var _theme2 = _interopRequireDefault(_theme);

var _place = require('../../../constants/place');

var _place2 = _interopRequireDefault(_place);

var _themes = require('../../../constants/themes');

var _themes2 = _interopRequireDefault(_themes);

var _helpers = require('../../../styled/helpers');

var _helpers2 = _interopRequireDefault(_helpers);

var _linkCustom = require('./linkCustom');

var _item = require('./item');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var SubMenuTitle = exports.SubMenuTitle = _styledComponents2.default.span(_templateObject(), function (props) {
  return props.place === _place2.default.Header && _styledComponents.css(_templateObject2());
});

var SubMenuList = exports.SubMenuList = (0, _styledComponents2.default)(_helpers2.default.ListReset)(_templateObject3(), function (props) {
  return props.place === _place2.default.Header && _styledComponents.css(_templateObject4(), _item.Item, _linkCustom.NavLink, _linkCustom.NavLinkNative);
}, function (props) {
  return props.place === _place2.default.Header && props.theme.name === _themes2.default.BLACK && _styledComponents.css(_templateObject5(), _linkCustom.NavLink, _linkCustom.NavLinkNative, _styled.colors.gray.gossamer, _styled.colors.gray.neutral);
});

var SubMenuListWrapper = exports.SubMenuListWrapper = _styledComponents2.default.div(_templateObject6(), function (props) {
  return props.place === _place2.default.Header && _styledComponents.css(_templateObject7());
}, _linkCustom.NavLink, _linkCustom.NavLinkNative);

var SubMenu = exports.SubMenu = _styledComponents2.default.li(_templateObject8(), function (props) {
  return props.place === _place2.default.Header && _styledComponents.css(_templateObject9(), SubMenuListWrapper);
});